"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/previewSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeSeventeenPreviewSectionGeneratedProps = {
    /** Default: "1s" */
    sectionDiv0H20H2DataWowDuration?: string;
    /** Default: "\"True wellness is not the absence of illness — it is the cultivation of" */
    sectionDiv0H20H2Text?: ReactNode;
    sectionDiv0H20H2Visible?: boolean;
    sectionDiv0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "a life fully lived, with energy, clarity, and deep inner peace.\"" */
    sectionDiv0H20Span0SpanText?: ReactNode;
    /** Default: "element" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-element-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "element" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-element-2.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeSeventeenPreviewSectionGenerated: FC<HomeSeventeenPreviewSectionGeneratedProps> = ({
    sectionDiv0H20H2DataWowDuration = "1s",
    sectionDiv0H20H2Text = "\"True wellness is not the absence of illness — it is the cultivation of",
    sectionDiv0H20H2Visible,
    sectionDiv0H20H2Renderer,
    sectionDiv0H20H2Props,
    sectionDiv0H20Span0SpanText = "a life fully lived, with energy, clarity, and deep inner peace.\"",
    sectionImageWithBasePath0ImageAlt = "element",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-element-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "element",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/banner/banner-element-2.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
}) => {
    return (
        <section className="preview-section-seventeen">
            <div className="container">
                {renderNode(sectionDiv0H20H2Visible, sectionDiv0H20H2Renderer, (
                    <h2 className="title wow fadeInDown" data-wow-duration={sectionDiv0H20H2DataWowDuration} {...(sectionDiv0H20H2Props ?? {})}>
                        {sectionDiv0H20H2Text}
                        <span>{sectionDiv0H20Span0SpanText}</span>
                    </h2>
                ))}
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-two" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSeventeenPreviewSectionGenerated;
